import { Component, Input } from '@angular/core';

@Component({
  selector: 'claims-athome-myaccount-manage-my-repair-detail-group',
  templateUrl: './detail-group.component.html',
  styleUrls: ['./detail-group.component.scss'],
})
export class ManageMyRepairDetailGroupComponent {
  @Input() groupTitle:
    | 'ADDRESS'
    | 'BOOKING_REFERENCE'
    | 'CALL'
    | 'CHANGE_BOOKING'
    | 'COLLECTION_DATE'
    | 'COLLECTION_ADDRESS'
    | 'DATE'
    | 'EMAIL'
    | 'ENGINEER_REPAIR'
    | 'ENGINEER_SERVICE'
    | 'FAULT_DETAILS'
    | 'NEXT_STEPS'
    | 'REPAIR_STATUS'
    | 'RETURN_ADDRESS'
    | 'TIME'
    | 'WEBSITE'
    | 'TRACK_BOOKING'
    | 'NEED_AN_UPDATE'
    | 'NEED_CHANGE_OR_CANCEL'
    | 'UPDATE_BODY'
    | 'CHANGE_CANCEL_BODY'
    | 'OTHER_QUESTIONS'
    | string;

  @Input() headingStyle?: 'inline';
}
